import React from "react";
import { Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const socialLinks = [
    { name: "Facebook", icon: <Facebook size={18} />, href: "https://www.facebook.com/profile.php?id=61576142563739" },
    { name: "Instagram", icon: <Instagram size={18} />, href: "https://www.instagram.com/springdales_theschool/" },
  ];

  return (
    <footer className="relative bg-[#B70404] text-white px-6 py-14 text-left overflow-hidden">
      <div className="max-16 mx-auto w-full footer flex flex-col md:flex-row justify-between gap-12 relative z-10">
        {/* Logo */}
        <div className="flex-shrink-0 w-full md:w-auto flex justify-center md:justify-start">
          <img
            src="https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621375/footer_ijnzf7.png"
            alt="Springdales Logo"
            className="w-full m-auto h-auto max-w-[200px] md:max-w-[250px]"
          />
        </div>

        {/* Middle Column - Links & Info */}
        <div className="flex-1 flex flex-col gap-6">
          {/* School Name */}
          <h2 className="text-xl md:text-2xl font-bold uppercase tracking-[.2em] text-center md:text-left">
            Springdales The School
          </h2>

          {/* Navigation Links */}
          <div className="text-sm flex flex-wrap items-start md:justify-start justify-start gap-x-2 gap-y-2 uppercase tracking-wider text-white/90">
            {[
              { name: "Home", href: "/" },
              { name: "About Us", href: "/about" },
              { name: "Our Programs", href: "/programs" },
              { name: "Our Gallery", href: "/gallery" },
              { name: "Why Us", href: "/whyus" },
              { name: "Contact", href: "/contact" },
            ].map((link, idx, arr) => (
              <React.Fragment key={link.name}>
                <a href={link.href} className="hover:underline hover:opacity-90 transition-all">
                  {link.name}
                </a>
                {idx < arr.length - 1 && <span className="text-white opacity-70 mx-1">•</span>}
              </React.Fragment>
            ))}
          </div>

          {/* School Hours */}
          <div className="text-xs opacity-80 text-left md:text-left">
            <strong>School Hours:</strong> Mon – Sat: 8:30 AM – 3:30 PM
          </div>

          {/* Quick Contact CTA */}
          <div className="text-sm text-left md:text-left">
            Have questions?{" "}
            <a href="/contact" className="underline font-semibold hover:text-white">
              Contact us
            </a>
          </div>
        </div>

        {/* Right Column - Contact Info & Social */}
        <div className="flex-1 flex flex-col gap-6">
          {/* Contact Info */}
          <div className="space-y-3 text-sm">
            <div className="flex items-start gap-2">
              <MapPin size={30} /> Springdales The School <br />
              5-169, Plot no. 76, Road No. 1, Chandra Nagar, Balanagar, Hyderabad, Telangana 500054, India
            </div>
            <div className="flex items-center gap-2">
              <Phone size={18} />  +91 9959921485 
            </div>
            <div className="flex items-center gap-2">
              <Mail size={18} /> <a href="mailto:springdalestheschool@gmail.com">springdalestheschool@gmail.com</a>
            </div>
          </div>

          {/* Social Media */}
          <div className="flex flex-wrap gap-3 text-sm uppercase tracking-widest">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-white text-[#B70404] px-3 py-1 rounded-full font-semibold text-xs hover:bg-gray-100 hover:scale-105 transition-transform"
              >
                {social.icon}
                {social.name}
              </a>
            ))}
          </div>

          {/* Copyright */}
          <div className="text-xs opacity-80">
            © {new Date().getFullYear()} Springdales The School. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
